<template>
  <div
    :class="{ 'justify-between': isInLobby || isJoinedMeeting }"
    id="meeting"
    :style="
      roomTheme != null && {
        backgroundColor: isJoinedMeeting
          ? roomTheme.roomBackgroundColor
          : roomTheme.waitingRoomBackgroundColor,
      }
    "
  >
    <img
      width="300"
      :src="roomTheme.logoURL"
      alt=""
      v-if="roomTheme != null && roomTheme.logoURL != null"
    />

    <div v-if="isRecording">RECORDING</div>

    <meeting-top-bar />

    <div class="meeting-body">
      <div class="text-center" v-if="notStarted">
        Waiting for the host to start the meeting
      </div>
      <div class="text-center" v-if="isEnteringLobby">Please wait...</div>
      <lobby v-else-if="isInLobby" />
      <div class="text-center" v-else-if="isJoiningMeeting">
        Joining meeting...
      </div>
      <div class="text-center" v-else-if="awaitingAccess">Awaiting access</div>
      <joined-meeting v-else-if="isJoinedMeeting"></joined-meeting>
      <div class="text-center" v-else-if="meetingAccessDenied">
        Access denied
      </div>
      <div class="text-center" v-else-if="hasMeetingError">
        An error occurred.
      </div>
      <div class="text-center" v-else-if="hasLeftMeeting">Left meeting</div>
      <div class="text-center" v-else-if="hasEnded">Meeting ended</div>
    </div>

    <meeting-bottom-bar
      v-if="localParticipant && (isInLobby || isJoinedMeeting)"
    />
  </div>
</template>

<script>
import TileGrid from "@/components/TileGrid";
import Participants from "@/components/Participants";
import roomInfoScreen from "@/components/roomInfoScreen.vue";
import userJoininDrop from "@/components/userJoininDrop.vue";
import meettingLockUnlock from "@/components/meettingLockUnlock.vue";
import ControlsWrap from "@/components/ControlsWrap";
import Lobby from "./meeting/Lobby";
import JoinedMeeting from "./meeting/JoinedMeeting";
import MeetingTopBar from "./new/MeetingTopBar";
import MeetingBottomBar from "./new/MeetingBottomBar";

export default {
  name: "Meeting",
  props: ["nickname"],
  components: {
    MeetingBottomBar,
    MeetingTopBar,
    JoinedMeeting,
    Lobby,
    ControlsWrap,
    Participants,
    TileGrid,
    roomInfoScreen,
    userJoininDrop,
    meettingLockUnlock,
  },

  data() {
    return {
      streamCaptionsClient: null,
      checkPermissionInterval: null,
      room_lock: false,
      not_logged_in: false,
      bgColor: "red",
    };
  },
  computed: {
    isRecording() {
      return this.$store.state.meeting.isRecording;
    },
    localParticipant() {
      return this.$store.getters.localParticipant;
    },
    isPublic() {
      return this.$store.state.meeting.meeting?.isPublic;
    },

    roomTheme() {
      return this.$store.getters.roomTheme;
    },
    cameraOrMicBlocked() {
      return this.$store.state.meeting.cameraOrMicBlocked;
    },
    hasEnded() {
      return this.$store.getters.hasEnded;
    },
    meetingAccessDenied() {
      return this.$store.getters.meetingAccessDenied;
    },
    awaitingAccess() {
      return this.$store.getters.awaitingAccess;
    },
    notStarted() {
      return this.$store.getters.notStarted;
    },
    isEnteringLobby() {
      return this.$store.getters.isEnteringLobby;
    },
    isInLobby() {
      return this.$store.getters.isInLobby;
    },
    isJoiningMeeting() {
      return this.$store.getters.isJoiningMeeting;
    },
    isJoinedMeeting() {
      return this.$store.getters.isJoinedMeeting;
    },
    hasLeftMeeting() {
      return this.$store.getters.hasLeftMeeting;
    },
    hasMeetingError() {
      return this.$store.getters.hasMeetingError;
    },
    ownerName() {
      this.$store.state.meeting?.participants.forEach((value, index) => {
        if (this.$store.state.meeting.participants[index].owner == true) {
          console.log(
            "user_name" +
              this.$store.state.meeting.participants[index].user_name
          );
          return this.$store.state.meeting.participants[index].user_name;
        }
      });
    },

    roomData() {
      return this.$store.state.meeting.roomData;
    },

    authenticated() {
      return this.$store.state.userAuthenticated;
    },

    hasAudioVideoAccess() {
      return this.$store.state.meeting.hasAudioVideoAccess;
    },

    meetingError() {
      return this.$store.state.meeting.meetingError;
    },

    cameraError() {
      return this.$store.state.meeting.cameraError;
    },

    user() {
      return this.$store.state.user;
    },

    meetingState() {
      return this.$store.state.meeting.currentState;
    },

    accessState() {
      return this.$store.state.meeting.accessState;
    },
    roomBackgroundColor() {
      return this.$store.state.meeting.meeting.roomTheme.roomBackgroundColor;
    },
    waitingRoomBackgroundColor() {
      return this.$store.state.meeting.meeting.roomTheme
        .watingRoomBackgroundColor;
    },
    meetingParticipants() {
      return this.$store.state.meeting.participants;
    },
  },

  watch: {
    hasAudioVideoAccess(hasAudioVideoAccess) {
      if (!hasAudioVideoAccess) {
        this.$store.commit("showModal", "premision_modal");
        this.checkPermissionInterval = setInterval(async () => {
          if (await this.$store.dispatch("grantAudioVideoAccess")) {
            clearInterval(this.checkPermissionInterval);
            await this.$store.dispatch("pullDevices");
          }
        }, 10);
      } else {
        this.$store.commit("hideModal");
      }
    },

    meetingState() {
      if (this.hasAudioVideoAccess) {
        this.$store.commit("showModal", "settings_modal");
      }
    },
  },

  methods: {
    leave() {
      this.$store.dispatch("leaveMeeting");
    },
  },

  async created() {
    await this.$store.dispatch("enterLobby", this.nickname);
    this.$store.subscribe(async (mutation) => {
      if (mutation.type === "reaction") {
        console.log("Reaction!", mutation.payload);
      } else if (mutation.type === "mention") {
        console.log("Mention!", mutation.payload);
      }
    });
  },

  beforeDestroy() {
    this.$store.dispatch("disposeMeetingResources");
  },
};
</script>

<style lang="scss">
.text-center {
  text-align: center;
}

#meeting {
  background-color: #f9f4ef;
  height: 100%;

  &.justify-between {
    justify-content: space-between;
  }

  gap: 1rem;

  @media screen and (min-width: 1024px) {
    gap: 2rem;
  }
}

.settings-section {
  display: flex;
  justify-content: space-between;
  padding: 0 16px !important;
}

#title {
  font-family: "NunitoSans-Bold";
  font-size: 16px;
  font-weight: 700;
  font-style: normal;
  letter-spacing: 0px;
  text-align: right;
  line-height: 24px;
}

#lock-title {
  color: rgba(0, 0, 0, 1);
  font-family: "NunitoSans-Bold";
  font-size: 16px;
  font-weight: 700;
  font-style: normal;
  letter-spacing: 0px;
  text-align: left;
  line-height: 24px;
  white-space: nowrap;
}

#count-title {
  font-family: "NunitoSans-Bold";
  font-size: 16px;
  font-weight: 700;
  font-style: normal;
  letter-spacing: 0px;
  text-align: right;
  white-space: nowrap;
  line-height: 24px;
  margin-left: 16px;
}

.meeting-body {
  margin-top: 1rem;
}
</style>
